import { render, staticRenderFns } from "./patentList.vue?vue&type=template&id=f1d8778a&scoped=true"
import script from "./patentList.vue?vue&type=script&lang=js"
export * from "./patentList.vue?vue&type=script&lang=js"
import style0 from "./patentList.vue?vue&type=style&index=0&id=f1d8778a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d8778a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1d8778a')) {
      api.createRecord('f1d8778a', component.options)
    } else {
      api.reload('f1d8778a', component.options)
    }
    module.hot.accept("./patentList.vue?vue&type=template&id=f1d8778a&scoped=true", function () {
      api.rerender('f1d8778a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/comps/patentList.vue"
export default component.exports